import { useContext } from 'react'
import { createContext } from 'react'

export declare class User {
  email?: string
  email_verified?: boolean
  sub?: string
  logins_count: number
}

export interface AuthState<TUser extends User = User> {
  error?: Error
  isAuthenticated: boolean
  isLoading: boolean
  user?: TUser
}

export interface BaseLoginOptions {
  /**
   * Provides a hint to Auth0 as to what flow should be displayed.
   * The default behavior is to show a login page but you can override
   * this by passing 'signup' to show the signup page instead.
   *
   * This only affects the New Universal Login Experience.
   */
  screen_hint?: 'signup' // | 'login' | string;
}

export interface RedirectLoginOptions extends BaseLoginOptions {
  /**
   * Used to store state before doing the redirect
   */
  appState?: any // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface LogoutOptions {
  returnTo?: string
}

export interface GetTokenSilentlyOptions {
  ignoreCache?: boolean
}

//  eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-unused-vars
export interface Auth0ContextInterface<TUser extends User = User> extends AuthState<TUser> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loginWithRedirect: (options?: RedirectLoginOptions) => Promise<void>

  // getAccessTokenSilently: {
  // (
  //   options: GetTokenSilentlyOptions & { detailedResponse: true }
  // ): Promise<GetTokenSilentlyVerboseResponse>;
  // (options?: GetTokenSilentlyOptions): Promise<string>;
  // (options: GetTokenSilentlyOptions): Promise<
  //   GetTokenSilentlyVerboseResponse | string
  // >;

  getAccessTokenSilently: {
    (options?: GetTokenSilentlyOptions): Promise<string>
  }

  logout: (options?: LogoutOptions) => void
}

const stub = (): never => {
  throw new Error('You forgot to wrap your component in <Auth0Provider>.')
}

const initialContext = {
  isAuthenticated: false,
  isLoading: true,
  loginWithRedirect: stub,
  getAccessTokenSilently: stub,
  logout: stub,
}

const Auth0Context = createContext<Auth0ContextInterface>(initialContext)

const useAuth0 = <TUser extends User = User>(context = Auth0Context): Auth0ContextInterface<TUser> =>
  useContext(context) as Auth0ContextInterface<TUser>

export { useAuth0 }
export { Auth0Context }
